import { Text } from '@doist/marketist';
import cn from 'clsx';
import { ProductUITaskCalendarMonth, type ProductUITaskCalendarMonthProps } from '../product-ui-task-calendar-month/product-ui-task-calendar-month';
import css from './product-ui-calendar-day.module.css';
export type ProductUICalendarDayProps = {
  date: Date;
  tasks?: React.ReactNode[];
};
function ProductUICalendarDay({
  tasks,
  date
}: ProductUICalendarDayProps) {
  return <div className={css.calendarDay} data-sentry-component="ProductUICalendarDay" data-sentry-source-file="product-ui-calendar-day.tsx">
            <div className={css.dateIndicatorContainer}>
                <ProductUICalendarDay.DateIndicator date={date} data-sentry-element="unknown" data-sentry-source-file="product-ui-calendar-day.tsx" />
            </div>
            {tasks ? tasks : null}
        </div>;
}
ProductUICalendarDay.Task = function (props: ProductUITaskCalendarMonthProps) {
  return <ProductUITaskCalendarMonth {...props} />;
};
ProductUICalendarDay.DateIndicator = function ({
  date
}: {
  date: Date;
}) {
  const day = date.getDate();
  return <Text tag="div" size="body-2xs" className={cn(css.dateIndicator, {
    [css.isToday]: isToday(date),
    [css.currentMonth]: isCurrentMonth(date)
  })}>
            {day}
        </Text>;
};
export { ProductUICalendarDay };
function isToday(date: Date) {
  const today = new Date();
  return date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
}
function isCurrentMonth(date: Date) {
  const today = new Date();
  return date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
}